import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { TicketDetailsSchema } from "../../Schemas/Ticket";

interface TicketDetailsUrlParams {
  ticketNumber: string;
}

export interface TicketDetailsResponseBody extends IResponseBody {
  data: {
    ticket: TicketDetailsSchema;
  };
}

export class TicketDetailsRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath(ticketDetailsUrlParams: TicketDetailsUrlParams) {
    return `/admin/tickets/${ticketDetailsUrlParams.ticketNumber}/details`;
  }

  async send(
    ticketDetailsUrlParams: TicketDetailsUrlParams
  ): Promise<TicketDetailsResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        this.getPath(ticketDetailsUrlParams)
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
